'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigations', ['$scope', '$stateParams', function ($scope, $stateParams) {
        //$scope.loading = true;
        $scope.previewID = $stateParams.previewID;
    }])
;